import React from 'react';
import DataTables from 'components/dataTables';
import { connect } from 'react-redux';
import { PostAction } from 'redux/actions';
import PageSpinner from 'components/PageSpinner';
import { Card } from 'reactstrap';
import PostContainer from './postContainer';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import noImage from 'assets/img/users/no-image.jpg';
import Avatar from 'components/Avatar';
import {DateFormat, checkPermissions} from 'hooks';
import { Link } from 'react-router-dom';

const Searches = (props) => {

    React.useEffect(() => {
        let filters = { page: props.pagination.page, page_limit: props.pagination.page_limit, order_by: props.order.order_by, direction: props.order.direction }
       if(props.userId){
           filters['userId'] =   props.userId;
       }
        props.getSearches(filters)
    }, [props.pagination, props.order,props.userId]);

    React.useEffect(() => {
        props.getTotalCount(props.totalRecord);
    }, [props.postList])

    const customBody = (value, tableMeta, updateValue) => {
        
        return (tableMeta.columnData.name==='image') ? 
        <Avatar src={(value) ? value : noImage}  />:
        (tableMeta.columnData.name==='created_at' || tableMeta.columnData.name==='updated_at')?DateFormat(value,'MM-DD-YYYY HH:mm:ss')
        :(tableMeta.columnData.name==='username')?(checkPermissions(props.loginData,'user_profile'))?<Link to={`/user-profile/${tableMeta.rowData[1]}`}>{value}</Link>:value
        :value;
    }
    const columns = () => {
        let columnsList = [
            {
                name: "id",
                label: "S.No.",
            },
            {
                name: "userId",
                label: "User Id",
            },
            {
                name: "image",
                label: "Image",
            },
            {
                name: "search_term",
                label: "Search Term",
            },
            {
                name: "type",
                label: "Type",
            },
            {
                name: "username",
                label: "Username",
            },
            {
                name: "title",
                label: "Title",
            },
            {
                name: "description",
                label: "Description",
            },
            {
                name: "created_at",
                label: "Created At",
            },
            {
                name: "updated_at",
                label: "Updated At",
            }
        ];
        return columnsList.map((column, index) => {
            return {
                label: column.label,
                name: column.name,
                options: {
                    customHeadRender: (columnMeta, updateDirection) => {
                        return <TableCustomHeader key={index} itemkey={index} order={props.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                    },
                    customBodyRender: customBody,
                    display: (column.name === 'id' || column.name === 'userId') ? false : true,
                    setCellProps: () => ({
                        style: (column.name === 'search_term' || column.name==='description' || column.name==='title') ? { maxWidth: "150px" }:{width:'auto'}
                    }),
                }
            }
        })
    }
    return (
        <Card className="mb-3">
            {props.isLoading ? <PageSpinner />
                : <DataTables data={props.postList} columns={columns()} options={props.options} />
            }</Card>
    );
}

const mapStateToProps = (state) => ({
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    postList: (state.post && state.post.searches && state.post.searches.posts) ? state.post.searches.posts : [],
    totalRecord: (state.post && state.post.searches && state.post.searches.total_posts) ? state.post.searches.total_posts : 0,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});
const mapDispatchToProps = (dispatch) => ({
    getSearches: (payload) => dispatch(PostAction.getSearches(payload)),
});
export default PostContainer(connect(mapStateToProps, mapDispatchToProps)(Searches), { defaultOrderBy: 'updated_at' });